import React from "react";

function ChevronDownIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="8"
      viewBox="0 0 14 8"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="currentColor" fillRule="nonzero">
          <path d="M13.8.762l-.62-.62a.377.377 0 00-.534 0L6.965 5.81 1.283.141a.377.377 0 00-.533 0L.129.762a.377.377 0 000 .534l6.569 6.57a.377.377 0 00.533 0l6.57-6.57a.377.377 0 000-.534z"></path>
        </g>
      </g>
    </svg>
  );
}

export default ChevronDownIcon;
